import script from "./type.vue?vue&type=script&setup=true&lang=js"
export * from "./type.vue?vue&type=script&setup=true&lang=js"

import "./type.vue?vue&type=style&index=0&id=4487e588&lang=css"

const __exports__ = script;

export default __exports__